<template>
  <div class="search-banner" id="find">
    <dialog-element 
      ref="dialog" 
      :data="linkData" 
      v-on:onClose="closeDialog"
    />
    <div class="search">
      <div class="title">ค้นหาชื่อร้านของคุณ<br />เพื่อสร้างลิงก์</div>
      <mobile-search 
        ref="mobileSearch" 
        :results="results"
        :placeholder="placeholder"
        :searchText="searchText"
        :showGenerateLink="showGenerateLink"
        :linkData="linkData"
        :showMoreResults="showMoreResults"
        v-on:onError="setInputError"
        v-on:onSearch="search"
        v-on:onNextPage="nextPage"
        v-on:showResult="showResult"
        v-on:showSearch="showSearch"
        v-on:clearSearch="clearSearch"
      />
      <desktop-search 
        ref="desktopSearch"
        :results="results"
        :placeholder="placeholder"
        :searchText="searchText"
        :showGenerateLink="showGenerateLink"
        :showMoreResults="showMoreResults"
        v-on:onError="setInputError"
        v-on:onSearch="search"
        v-on:onNextPage="nextPage"
        v-on:showResult="showResult"
        v-on:showSearch="showSearch"
        v-on:clearSearch="clearSearch"
      />
    </div>
    <img 
      alt="Banner Image"
      class="desktop-only"
      src="@/assets/landing-banner-2.jpg"
      srcset="@/assets/landing-banner-2@2x.jpg 2x,
              @/assets/landing-banner-2@3x.jpg 3x"
    />
    <img 
      alt="Banner Image"
      class="mobile-only"
      src="@/assets/landing-banner-2-mobile.jpg"
      srcset="@/assets/landing-banner-2-mobile@2x.jpg 2x,
              @/assets/landing-banner-2-mobile@3x.jpg 3x"
    />
  </div>
</template>

<script>
  import Dialog from '@/components/dialog';
  import MobileSearch from '@/components/mobile-search';
  import DesktopSearch from '@/components/desktop-search';
  import {FETCH_SEARCH} from '@/store/actions.type';
  import {mapGetters} from 'vuex';

  export default {
    components: {
      'dialog-element': Dialog,
      'mobile-search': MobileSearch,
      'desktop-search': DesktopSearch,
    },
    methods: {
      search: function(searchText) {
        if (searchText.replace(/\s/g, '')) {
          this.clearInputError();
          this.desktopSearch.showDropdown();
          if (this.searchText !== searchText) {
            this.results = {};
            this.searchText = searchText;
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
              this.$store.dispatch(FETCH_SEARCH, {
                keyword: searchText
              }).then((res) => {
                if (this.searchText === res.payload.keyword) {
                  this.results = res.response.data;
                  this.hasMoreResults();
                }
              });
            }, this.searchTimeoutInterval);
          }
        }
        else {
          this.desktopSearch.hideDropdown();
        }
      },
      hasMoreResults: function() {
        const page = this.results.page;
        if (page.number < page.totalNumberOfPages) {
          this.showMoreResults = true;
          return true;
        }
        else {
          this.showMoreResults = false;
          return false;
        }
      },
      nextPage: function() {
        if (this.hasMoreResults()) {
          this.$store.dispatch(FETCH_SEARCH, {
            keyword: this.searchText,
            query: {
              'page.number': this.results.page.number + 1
            }
          }).then((res) => {
            if (this.searchText === res.payload.keyword) {
              this.results.page = res.response.data.page;
              this.results.datas = this.results.datas.concat(res.response.data.datas);
              this.hasMoreResults();
            }
          });
        }
      },
      clearSearch: function() {
        clearTimeout(this.searchTimeout);
      },
      setInputError: function() {
        this.placeholder = 'กรุณาใส่ชื่อร้านที่นี่เพื่อสร้างลิงก์';
        const desktopInput = this.desktopSearch.$refs.input;
        const mobileInput = this.mobileSearch.$refs.input;
        desktopInput.setAttribute('error', '');
        mobileInput.setAttribute('error', '');
      },
      clearInputError: function() {
        this.placeholder = 'ใส่ชื่อร้านอาหารของคุณที่นี่';
        const desktopInput = this.desktopSearch.$refs.input;
        const mobileInput = this.mobileSearch.$refs.input;
        desktopInput.removeAttribute('error');
        mobileInput.removeAttribute('error');
      },
      showResult: function(index) {
        this.showGenerateLink = true;
        this.linkData = this.results.datas[index];
        this.$refs.dialog.show();
        this.desktopSearch.hideSearch();
      },
      showSearch: function() {
        const body = document.body;
        body.setAttribute('search-active', '');
        if (body.offsetWidth < 720) {
          this.mobileSearch.focusInput();
        }
        this.clearInputError();
        this.mobileSearch.show();
      },
      closeDialog: function() {
        this.searchText = '';
        this.mobileSearch.hideSearch();
      },
    },
    data: () => ({
      linkData: {},
      searchText: '',
      results: {},
      placeholder: 'ใส่ชื่อร้านอาหารของคุณที่นี่',
      showGenerateLink: false,
      searchTimeoutInterval: 300,
      showMoreResults: false,
    }),
    mounted: function() {
      this.desktopSearch = this.$refs.desktopSearch;
      this.mobileSearch = this.$refs.mobileSearch;
    }
  }
</script>

<style lang="scss" scoped>
  .search-banner {
    position: relative;

    img {
      vertical-align: middle;
      width: 100%;
      min-height: 560px;
      object-fit: cover;
      font-family: 'object-fit: cover';
    }
  }

  .search {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & > .title {
      text-align: center;
      font-size: 48px;
      line-height: 58px;
      font-weight: 700;
      margin-bottom: 16px;
    }
  }

  @media screen and (max-width: 720px) {
    .search > .title {
      font-size: 24px;
      line-height: 30px;
    }
    .search-banner img {
      min-height: initial;
    }
  }
</style>